import { ResourceType } from "@/services/cloudchipr.api";

export const resourceTypesThatCanHaveCoverage = new Set<ResourceType>([
  // aws
  "ec2",
  "asg_ec2",
  "eks_ec2",
  "rds",
  "elc",
  "dynamo_db_table",
  "ecs_workload",
  "eks",
  // azure
  "az_vm",
  "az_vmss",
  "az_aks_vm",
  "az_vmss_vm",
  "az_sql",
  "az_aks",
]);
